(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function initGallery(root) {
    var main = root.querySelector('[data-main-img]');
    if (!main) return null;
    var thumbs = root.querySelectorAll('[data-thumb]');
    function show(thumb) {
      main.src = thumb.getAttribute('data-src');
      main.srcset = thumb.getAttribute('data-srcset') || '';
      main.alt = thumb.getAttribute('data-alt') || main.alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    return {
      showMedia: function (mediaId) {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-media-id') === String(mediaId)) { show(thumbs[i]); return; }
        }
      }
    };
  }

  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = section.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var nfPriceEl = section.querySelector('[data-nf-price]');
    var button = form.querySelector('[data-add]');
    var buttonLabel = button ? button.getAttribute('data-label') : '';
    var gallery = initGallery(section);
    var groups = section.querySelectorAll('[data-option-index]');

    function selected() {
      var values = [];
      groups.forEach(function (g) {
        var checked = g.querySelector('input:checked');
        values[+g.getAttribute('data-option-index')] = checked ? checked.value : null;
      });
      return values;
    }

    function update() {
      var values = selected();
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < values.length; j++) { if (v.options[j] !== values[j]) { ok = false; break; } }
        if (ok) { variant = v; break; }
      }
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Not on the menu'; }
        return;
      }
      idInput.value = variant.id;
      var price = formatMoney(variant.price, moneyFormat);
      if (priceEl) priceEl.textContent = price;
      if (nfPriceEl) nfPriceEl.textContent = price;
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? buttonLabel : 'Sold out – 86d';
      }
      if (gallery && variant.featured_media) gallery.showMedia(variant.featured_media.id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g) { g.addEventListener('change', update); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  });
})();
